import { useMutation, useQueryClient } from '@tanstack/react-query';

export default function usePdfMutations({ projectId }) {
  const queryClient = useQueryClient();

  const createPdfMutation = useMutation({
    mutationFn: async (uploadKey) => {
      const response = await axios.post(`/projects/${projectId}/pdfs`, {
        pdf: { key: uploadKey },
      });
      return response.data;
    },
    onSuccess: () => queryClient.invalidateQueries(['projectPdfs', projectId]),
  });

  const deletePdfMutation = useMutation({
    mutationFn: async (pdfId) => {
      const response = await axios.delete(
        `/projects/${projectId}/pdfs/${pdfId}`,
      );
      return response.data;
    },
    onSuccess: () => queryClient.invalidateQueries(['projectPdfs', projectId]),
  });

  const updateCoverSheetSelectionMutation = useMutation({
    mutationFn: async ({ pdfId, selected }) => {
      const response = await axios.patch(
        `/projects/${projectId}/cover_sheet_selection`,
        {
          cover_sheet_selection: { selected, attachment_id: pdfId },
        },
      );
      return response.data;
    },
    onSuccess: () => queryClient.invalidateQueries(['projectPdfs', projectId]),
  });

  const updatePdfPositionMutation = useMutation({
    mutationFn: async (params) => {
      const response = await axios.patch(
        `/projects/${projectId}/pdf_position_configuration`,
        params,
      );
      return response.data;
    },
    onSuccess: () => queryClient.invalidateQueries(['projectPdfs', projectId]),
  });

  return {
    createPdfMutation,
    deletePdfMutation,
    updateCoverSheetSelectionMutation,
    updatePdfPositionMutation,
  };
}
